import {useEffect,useRef} from "react";

// Opt in only for read-only requests. This does not synchronize external
// providers, analyze data or execute an assistant action.
export const useVisibleRefresh=(refresh,{enabled=false,intervalMs=60000,updatedAt=null}={})=>{
  const latest=useRef();latest.current={refresh,updatedAt};
  const lastStarted=useRef(Date.now());
  const running=useRef(false);
  useEffect(()=>{
    if(!enabled||!Number.isFinite(intervalMs)||intervalMs<10000)return undefined;
    let active=true;
    const tick=async()=>{
      const now=Date.now();
      const readTime=latest.current.updatedAt?.getTime?.();
      const age=now-Math.max(lastStarted.current,Number.isFinite(readTime)?readTime:0);
      if(!active||running.current||document.visibilityState!=="visible"||navigator.onLine===false||age>=0&&age<10000)return;
      running.current=true;lastStarted.current=now;
      try{await latest.current.refresh();}catch{/* Reader owns its visible error state. */}
      finally{running.current=false;}
    };
    const restored=event=>{if(event.persisted)tick();};
    const timer=window.setInterval(tick,intervalMs);
    window.addEventListener("focus",tick);window.addEventListener("online",tick);
    document.addEventListener("visibilitychange",tick);window.addEventListener("pageshow",restored);
    return()=>{active=false;window.clearInterval(timer);window.removeEventListener("focus",tick);window.removeEventListener("online",tick);document.removeEventListener("visibilitychange",tick);window.removeEventListener("pageshow",restored);};
  },[enabled,intervalMs]);
};
